import React from 'react';
import { graphql } from "react-apollo";

import { users } from '../../graphql/queries';
import { ColHead, ColError, ColLoading } from '../chunk'
import Tile from "../Tile"


class UserList extends React.Component {
	render() {

		let { loading, error, users } = this.props.data;

		if( loading ) return (<div className="col col-2"><ColLoading /></div>)
		if( error ) return (<div className="col col-2"><ColError error={error} /></div>)

		return (
			<div className="col col-2">
            	<ColHead icon="users" title="USER LIST" meta={`${users.length} Users`} />

		        <div className="grid-list grid-list-small">
			        {users.map(({ id, name, avatar }) => (
			        	<Tile key={id} id={id} text={name} url={`/users/${id}/`} bg={`/avatare/${avatar}`} />
		      		))}
		        </div>
		    </div>
      	)
	}
}


export default graphql(users)(UserList)


// WEBPACK FOOTER //
// ./src/components/user/UserList.js